<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">Classic Children’s Adventure Stories</p>
<p class="bk-subtitle">Peter Pan, The Wonderful Wizard of Oz, Alice’s Adventures in Wonderland, The Swiss Family Robinson</p>
<p class="publisher"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?e5adc980